<template>
	<v-dialog
		v-model="localShowDialog"
		:width="$vuetify.display.mobile ? '95%' : '500px'"
		@click:outside="closeDialog"
		@keydown.esc="closeDialog"
		@keydown.enter="setValue"
	>
		<v-card class="sgnl-pb-4">
			<v-card-title class="dialog-header sgnl-subtitle-medium">
				{{ title }}
				<v-spacer />
				<v-btn
					icon
					variant="text"
					size="small"
					@click="closeDialog"
				>
					<Close16 />
				</v-btn>
			</v-card-title>
			<v-divider />
			<v-card-text class="dialog-body">
				<v-form
					ref="mainForm"
					v-model="formValid"
				>
					<div class="input-group">
						<div class="field-label">{{ valueHint }}</div>
						<v-text-field
							placeholder="valueHint"
							v-model="newValue"
							class="sgnl-mb-neg-8"
							maxlength="50"
							:rules="[rules.required, rules.counter]"
							:counter="50"
							autofocus
						/>
					</div>
				</v-form>
			</v-card-text>
			<v-divider />
			<v-card-actions class="dialog-footer">
				<v-btn
					variant="outlined"
					@click="closeDialog"
					>Cancel</v-btn
				>
				<v-btn
					variant="flat"
					color="primary"
					@click="setValue"
					:disabled="!formValid"
				>
					Set {{ valueHint }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Close16 from "@carbon/icons-vue/es/close/16";
export default defineComponent({
	name: "EditValueDialog",
	components: { Close16 },
	props: {
		showDialog: { type: Boolean, default: false },
		title: { type: String, required: true },
		valueHint: { type: String, required: true },
		value: { type: String, default: "" },
	},
	emits: {
		"update:showDialog": (_data: boolean) => true,
		"update:value": (_data: string) => true,
	},
	data: () => ({
		newValue: "",
		formValid: false,
		rules: {
			required: (value: string) => !!value || "Required.",
			counter: (value: string) => value.length <= 50 || "Max 50 characters",
		},
	}),
	computed: {
		localShowDialog: {
			get() {
				return this.showDialog;
			},
			set(value) {
				this.$emit("update:showDialog", value);
			},
		},
	},
	methods: {
		closeDialog() {
			this.$emit("update:showDialog", false);
		},
		setValue() {
			if (this.formValid) {
				this.$emit("update:value", this.newValue.trim());
				this.closeDialog();
			}
		},
	},
	mounted() {
		this.newValue = this.value;
	},
});
</script>
